/* =====================================================================
   MAIUS: Sepet cekmecesi
   1) Sepete ekleyince baslik "Urun Sepetinize Eklendi" olur, sepet ikonundan acilinca "Sepet".
   2) "Begenebilecekleriniz": Shopify'in kendi urun onerileri (sepetteki ilk urune gore),
      sepette olan ve stokta olmayan urunler atlanir, 2 urun gosterilir.
   theme.js'e dokunmaz; temanin cart:change / cart-drawer:refreshed olaylarini dinler.
   ===================================================================== */
(function () {
  if (window.__maiusCartDrawer) return;
  window.__maiusCartDrawer = true;

  var cache = {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(box, products) {
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var picks = products.filter(function (p) {
      return p.available && exclude.indexOf(String(p.id)) === -1;
    }).slice(0, 2);
    var grid = box.querySelector('.maius-cd-recs__grid');
    if (!picks.length || !grid) { box.hidden = true; return; }
    grid.innerHTML = picks.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      return '<a class="maius-cd-rec" href="' + esc(p.url) + '">' +
        '<span class="maius-cd-rec__media"><img src="' + esc(imgUrl(img, 400)) + '" srcset="' +
        esc(imgUrl(img, 200)) + ' 200w, ' + esc(imgUrl(img, 400)) + ' 400w" sizes="181px" alt="' + esc(p.title) + '" loading="lazy"></span>' +
        '<span class="maius-cd-rec__title">' + esc(p.title) + '</span></a>';
    }).join('');
    box.hidden = false;
  }

  function fillRecs() {
    var d = drawer();
    var box = d && d.querySelector('.maius-cd-recs[data-product-id]');
    if (!box) return;
    var id = box.getAttribute('data-product-id');
    if (!id) return;
    if (cache[id]) { render(box, cache[id]); return; }
    fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        cache[id] = j.products || [];
        var cur = drawer() && drawer().querySelector('.maius-cd-recs[data-product-id="' + id + '"]');
        if (cur) render(cur, cache[id]);
      })
      .catch(function () {});
  }

  document.addEventListener('cart:change', function (e) {
    var d = drawer();
    if (!d) return;
    if (e.detail && e.detail.baseEvent === 'variant:add') d.classList.add('maius-just-added');
  });

  function bind() {
    var d = drawer();
    if (!d || d.__maiusBound) return;
    d.__maiusBound = true;
    d.addEventListener('cart-drawer:refreshed', fillRecs);
    d.addEventListener('dialog:before-show', fillRecs);
    d.addEventListener('dialog:after-hide', function () { d.classList.remove('maius-just-added'); });
    fillRecs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
